import { AuthService } from "./../../shared/models/auth.service";
import { Injectable, Inject } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { UserProfileModel } from "./userprofile.model";
import { ChangePasswordModel } from "./changepassword.model";
import { Observable } from "rxjs/Observable";
import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";

@Injectable()
export class UserProfileService {
  constructor(private authService: AuthService, private http: Http) {}

  public GetUserByPersonHashId(): Observable<IAPIResponse> {
    //let getPersonUrl = WeGoConfig.API_GET_PERSON_BY_HASH + "?personHashId=" + personHashId;
    let getPersonUrl = WeGoConfig.API_GET_PROFILE_DETAIL;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetCreditCardDetailsByPersonHashId(): Observable<IAPIResponse> {
    let getCredtiCardUrl = WeGoConfig.API_GET_CREDITCARD_DETAILS;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCredtiCardUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  
  public UpdateUserProfile(
    personModel: UserProfileModel
  ): Observable<IAPIResponse> {
    let body = personModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_UserPROFILE_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public SubmitChangePassword(
    changepasswordModal: ChangePasswordModel
  ): Observable<IAPIResponse> {
    let body = changepasswordModal;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_CHANGEUSERPASSSWORD, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DeleteCreditCardDetails(
    creditCardHashId: string
  ): Observable<IAPIResponse> {
    let deleteCreditCardDetails =
      WeGoConfig.API_DELETE_CREDITCARD_DETAILS_BYHASHID +
      "?creditCardHashId=" +
      creditCardHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(deleteCreditCardDetails, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/userprofile/models/userprofile.service.ts